import { AsyncPipe, NgClass } from '@angular/common'
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { AssetsPipe } from '@gofive/angular-common'
import { Applications, Configuration as ConfigurationDesignSystem, Themes } from '@gofive/design-system-base'
import { TranslateService } from '@ngx-translate/core'
import { UrlHelperService } from 'angular-oauth2-oidc'
import { Subject, map, share } from 'rxjs'
import { TypePathLocation } from 'src/domain/enums/type-path.enum'
import { AuthService } from 'src/domain/services/auth/auth.service'
import { SettingsService } from 'src/domain/services/setting/settings.service'
import { GetUserUseCase } from 'src/domain/usecases/client/get-user.usecase'
import { GetMenuItemUseCase } from 'src/domain/usecases/component/get-menu-item.usecase'
import { environment } from '../environments/environment'
import { MySwalComponent } from './components/my-swal/my-swal.component'

@Component({
	templateUrl: './app.component.html',
	selector: 'app-root',
	standalone: true,
	imports: [RouterOutlet, MySwalComponent, NgClass, AsyncPipe],
	providers: [UrlHelperService, TranslateService, AssetsPipe, GetUserUseCase, GetMenuItemUseCase],
})
export class AppComponent implements OnInit, OnDestroy {
	public location: number = TypePathLocation.Default
	public config: Object[] = []
	private _unsubscribeAll: Subject<any> = new Subject<any>()

	@ViewChild('mySwalComponent', { static: false })
	mySwalComponent: MySwalComponent

	get TypePathLocation() {
		return TypePathLocation
	}
	get isLocal() {
		return environment.envName === 'dev' || environment.envName === 'uat-dev' || environment.envName === 'uat'
	}

	constructor(
		public authService: AuthService,
		public settingsService: SettingsService,
		private translateService: TranslateService,
		private assetsPipe: AssetsPipe,
		private getUserUseCase: GetUserUseCase,
		private getMenuItemUseCase: GetMenuItemUseCase,
	) {
		this.settingsService.currentLanguage.subscribe((lang) => {
			this.translateService.use(lang)
		})
		this.authService.runInitialLoginSequence()

		this.setLoadingLocation()

		ConfigurationDesignSystem.setLibConfig({
			theme: Themes.EmpeoLight,
			application: Applications.Empeo,
		})

		let lang = localStorage.getItem('user_prefered_language') || 'th'
		this.translateService.addLangs(['th', 'en'])
		this.translateService.setDefaultLang(lang)
		this.translateService.use(lang)
		this.settingsService.setLang(lang)

		this.settingsService.menuItem$ = this.getMenuItemUseCase.execute().pipe(share())

		this.settingsService.clientId = this.getUserUseCase.execute().pipe(
			map((res) => {
				return res['data']
			}),
			share(),
		)
	}

	ngOnDestroy(): void {
		this._unsubscribeAll.next(null)
		this._unsubscribeAll.complete()
	}

	ngOnInit(): void {
		fetch(environment.microApp + 'assets/configurations/config.json?v=' + new Date().getTime())
			.then((response) => response.json())
			.then((config) => {
				this.config = config
				this.loadStyles()
			})
	}

	loadStyles() {
		const styles = ['styles/styles.css']
		const assets = [
			'assets/fonts/gofive/styles.css',
			'assets/fonts/sukhumvit/stylesheet.css',
			'assets/icons/goficon/style.css',
			'assets/icons/go5-icon/style.css',
		]
		let version = this.isLocal ? Math.floor(new Date().getTime()).toString() : this.config['gofive-styles-css'].version
		styles?.forEach((url) => {
			let x = document.createElement('LINK')
			x.setAttribute('rel', 'stylesheet')
			x.setAttribute('type', 'text/css')
			x.setAttribute('href', environment.microApp + url + '?version=' + version)
			document.head.appendChild(x)
		})

		assets?.forEach((url) => {
			let x = document.createElement('LINK')
			x.setAttribute('rel', 'stylesheet')
			x.setAttribute('type', 'text/css')
			x.setAttribute('href', environment.microApp + url + '?version=' + version)
			document.head.appendChild(x)
		})
	}

	setLoadingLocation() {
		const pathLocation = window.location.pathname
		if (pathLocation.search('/venio') > -1) {
			this.location = TypePathLocation.Venio
		} else if (pathLocation.search('/empeo') > -1) {
			this.location = TypePathLocation.Empeo
		} else this.location = TypePathLocation.Default
	}

	get typeLang() {
		return this.translateService.currentLang === 'th' ? 'th-TH' : 'en-GB'
	}

	// skipcq: JS-0105
	shouldSkipLoading() {
		const url = window.location.href
		return url.includes('m-subscription?')
	}
}
